<button
    *ngIf="question.validation_rules_f === 'required'"
    class="btn btn-primary"
    (click)="toggleSkipButton(question)"
    tabindex="-1">
  <span *ngIf="!question.skipped; else text_unskip">Skip</span>
  <ng-template #text_unskip>
    Un-Skip
  </ng-template>
</button>